import { CheckIcon } from '@heroicons/react/24/solid';
import { startCase } from 'lodash-es';
import { useTranslation } from 'next-i18next';
import AmenityIcon from '../ui/AmenityIcon';

export default function CompanyFeatures({ company }) {
	const { t } = useTranslation('common');

	const includedFeatures = Object.keys(company.features)
		.map((feature) => {
			if (company.features[feature] === false) {
				return null;
			}
			const translatedFeatures = t(`common:amenities`, {
				returnObjects: true,
			});
			const featureTranslation = translatedFeatures[feature];
			let featureName = null;
			if (!featureTranslation) {
				featureName = startCase(feature);
			} else {
				featureName = featureTranslation.name;
			}
			return {
				id: feature,
				name: featureName,
			};
		})
		.filter(Boolean);

	return (
		includedFeatures.length > 0 && (
			<section id="features" className="bg-white">
				<div>
					<div className="rounded-xl ring-1 ring-gray-200">
						<div className="p-4 sm:p-10 lg:flex-auto">
							<h2 className="text-2xl font-bold tracking-tight text-gray-900 lg:text-3xl">
								{t(`common:amenities.title`, { company: company.name })}
							</h2>
							<p className="mt-4 text-base text-gray-600">
								{t(`common:amenities.description`)}
							</p>
							<div className="mt-8 flex items-center gap-x-4">
								<h3 className="text-sm/6 flex-none font-semibold text-blue-600">
									{t(`common:amenities.subtitle`)}
								</h3>
								<div className="h-px flex-auto bg-gray-100" />
							</div>
							<ul
								role="list"
								className="mt-8 grid grid-cols-1 gap-4 text-sm text-gray-600 sm:grid-cols-2 sm:gap-6"
							>
								{includedFeatures.map((feature) => (
									<li key={feature.id} className="flex items-center gap-x-3">
										<AmenityIcon
											FallbackIcon={CheckIcon}
											amenityId={feature.id}
											className="h-6 w-5 flex-none text-blue-600"
										/>
										{feature.name}
									</li>
								))}
							</ul>
						</div>
					</div>
				</div>
			</section>
		)
	);
}
